export default theme => ({
    iconWrapper: {
        padding: theme.spacing(0, 2, 0, 2),
        display: 'inline-block',
    },
});
